import { render, staticRenderFns } from "./RoasterUpload.vue?vue&type=template&id=7280264c&scoped=true&"
import script from "./RoasterUpload.vue?vue&type=script&lang=ts&"
export * from "./RoasterUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7280264c",
  null
  
)

export default component.exports